import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { DA_XUAT_BAN } from "../data/glossary.js";
import { TOOLS } from "../data/tools.js";
import { CONG_CU } from "../data/nextSteps.js";
import NextStep from "./NextStep.jsx";
import { viecTiepTheo, linkViec, linkTram, SO_TRAM } from "../data/lo-trinh.js";
import { KHOA_NGANH } from "../lib/goiYTram.js";
import {
  normalize,
  saveDraft,
  saveScenario,
  currentDraft,
  stageDraft,
} from "../lib/workspace.js";
import { track, trackOnce } from "../lib/track.js";
import { taiKhoanHienTai } from "../lib/workspace.js";
import { CO_CAU_HINH } from "../lib/firebase.js";
import { theoDoiDangNhap } from "../lib/auth.js";

const KHOA_AN_GOI_Y = "fr-an-goi-y-dang-nhap";
/** Biểu tượng nét mảnh 16px cho hàng thông tin và hàng nút ở đầu trang công cụ. */
const HINH_NHO = {
  "dong-ho": <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  may: <><rect x="3" y="4" width="18" height="12" rx="1.5" /><path d="M8 20h8M12 16v4" /></>,
  "mo-khoa": <><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 7.5-2" /></>,
  sach: <><path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z" /><path d="M4 19V5M8 7h7" /></>,
  xuong: <><path d="M12 4v15M6 13l6 6 6-6" /></>,
  "danh-dau": <><path d="M6 3h12v18l-6-4-6 4z" /></>,
  luu: <><path d="M5 3h11l3 3v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z" /><path d="M8 3v5h7V3M8 21v-7h8v7" /></>,
};
function IconNho({ ten }) {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {HINH_NHO[ten]}
    </svg>
  );
}


/**
 * Công cụ dạng danh sách kiểm tra chỉ có một trạng thái đúng của doanh
 * nghiệp, không có "phương án" để so sánh, nên không hiện nút lưu kịch bản.
 */
const KHONG_CO_KICH_BAN = new Set(["legal-checklist", "pitch-deck", "readiness-score"]);
const daAnGoiY = () => {
  try { return sessionStorage.getItem(KHOA_AN_GOI_Y) === "1"; } catch { return false; }
};

/**
 * Gợi ý nhẹ sau khi lưu: dữ liệu đang nằm trên thiết bị này, đăng nhập email để
 * không mất khi đổi máy. Không chặn kết quả, tắt được, không hiện lại trong
 * cùng phiên. Chỉ hiện khi website đã cấu hình đăng nhập và người dùng chưa đăng nhập.
 */
function GoiYDangNhap({ onTat }) {
  const [daDangNhap, setDaDangNhap] = useState(Boolean(taiKhoanHienTai()));
  useEffect(() => {
    if (daDangNhap) return undefined;
    return theoDoiDangNhap((u) => setDaDangNhap(Boolean(u)));
  }, [daDangNhap]);
  useEffect(() => {
    if (!daDangNhap) trackOnce("goi-y-dang-nhap", "login_prompt_shown", { kind: "after_save" });
  }, [daDangNhap]);
  if (daDangNhap) return null;
  return (
    <div className="goi-y-luu" role="note">
      <p>
        <strong>Đã lưu trên thiết bị này.</strong> Đổi máy hoặc xoá dữ liệu trình
        duyệt sẽ mất bản lưu.{" "}
        <Link to="/ban-chuan-bi/tai-khoan">Đăng nhập bằng email để đồng bộ →</Link>
      </p>
      <button type="button" className="nut-tat" aria-label="Ẩn gợi ý" onClick={onTat}>
        ✕
      </button>
    </div>
  );
}
export default function ToolJourney({ tool }) {
  const [q, setQ] = useState("");
  const [message, setMessage] = useState("");
  const [goiY, setGoiY] = useState(false);
  const moGoiY = () => {
    if (CO_CAU_HINH && !daAnGoiY()) setGoiY(true);
  };
  const tatGoiY = () => {
    try { sessionStorage.setItem(KHOA_AN_GOI_Y, "1"); } catch { /* bỏ qua */ }
    setGoiY(false);
  };
  const dialog = useRef(null);
  const terms = DA_XUAT_BAN.filter((t) =>
    q
      ? normalize(t.term + " " + t.aliases.join(" ")).includes(normalize(q))
      : t.relatedTools.includes(tool.toolId),
  ).slice(0, 12);
  function scenario() {
    if (!document.querySelector(".tool-form input")) {
      setMessage("Chờ công cụ mở xong trước khi lưu.");
      return;
    }
    const name = prompt("Tên kịch bản (ví dụ: Thận trọng)");
    if (!name?.trim()) return;
    try {
      const text = [...document.querySelectorAll(".tool-form .ket-qua")]
        .map((el) => el.innerText)
        .join("\n");
      saveScenario(tool.toolId, name.trim().slice(0, 100), text);
      track("prep_save", { tool: tool.toolId, kind: "scenario" });
      moGoiY();
      setMessage("Đã lưu kịch bản. So sánh trong Bản chuẩn bị của tôi.");
    } catch (err) {
      setMessage("Chưa lưu được kịch bản. " + err.message);
    }
  }
  function save() {
    if (!document.querySelector(".tool-form input")) {
      setMessage("Chờ công cụ mở xong trước khi lưu.");
      return;
    }
    try {
      const text = [...document.querySelectorAll(".tool-form .ket-qua")]
        .map((el) => el.innerText)
        .join("\n");
      saveDraft(tool.toolId, text);
      track("prep_save", { tool: tool.toolId, kind: "draft" });
      moGoiY();
      setMessage(
        "Đã lưu bản nháp trên thiết bị này. Bấm lưu lại sau khi chỉnh sửa.",
      );
    } catch {
      setMessage(
        "Chưa lưu được. Bộ nhớ trình duyệt có thể bị chặn hoặc đã đầy.",
      );
    }
  }
  return (
    <>
      <div className="tool-actions tc-thanh">
        <ul className="tc-meta" aria-label="Thông tin nhanh">
          <li><IconNho ten="dong-ho" />{tool.minutes} phút</li>
          <li><IconNho ten="may" />Tính ngay trên máy bạn</li>
          <li className="tc-meta-phu"><IconNho ten="mo-khoa" />Không cần tài khoản</li>
        </ul>
        <div className="tc-nut" role="group" aria-label="Thao tác">
          <button type="button" className="tc-nut-icon" onClick={() => dialog.current.showModal()} title="Tra nghĩa thuật ngữ ngay tại trang">
            <IconNho ten="sach" /><span>Thuật ngữ</span>
          </button>
          {tool.toolId !== "readiness-score" && (
            <button
              type="button"
              className="tc-nut-icon"
              title="Cuộn tới khung kết quả"
              onClick={() => {
                const el = document.querySelector(".tool-form .ket-qua");
                if (el) {
                  el.scrollIntoView({ block: "start" });
                  el.setAttribute("tabindex", "-1");
                  el.focus({ preventScroll: true });
                }
              }}
            >
              <IconNho ten="xuong" /><span>Kết quả</span>
            </button>
          )}
          {!KHONG_CO_KICH_BAN.has(tool.toolId) && (
            <button type="button" className="tc-nut-icon" onClick={scenario} title="Đặt tên và lưu phương án này để so sánh với phương án khác">
              <IconNho ten="danh-dau" /><span>Lưu kịch bản</span>
            </button>
          )}
          <button
            type="button"
            className="tc-nut-icon"
            onClick={save}
            title="Dữ liệu đang nhập được giữ khi chuyển trang trong phiên này. Bấm để lưu và mở lại sau khi đóng trình duyệt."
          >
            <IconNho ten="luu" /><span>Lưu nháp</span>
          </button>
        </div>
      </div>
      <p className="save-status" role="status">{message}</p>
      {goiY && <GoiYDangNhap onTat={tatGoiY} />}
      <dialog
        ref={dialog}
        className="term-dialog"
        aria-labelledby="quick-term-heading"
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            e.preventDefault();
            dialog.current.close();
          }
        }}
      >
        <div className="section-bar">
          <h2 id="quick-term-heading">Tra cứu tại chỗ</h2>
          <button
            className="nut phu"
            onClick={() => dialog.current.close()}
            autoFocus
          >
            Đóng ✕
          </button>
        </div>
        <label htmlFor="quick-term">Thuật ngữ</label>
        <input
          id="quick-term"
          type="search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Nhập thuật ngữ…"
        />
        {terms.map((t) => (
          <details key={t.slug}>
            <summary>{t.term}</summary>
            <p>{t.shortDef}</p>
            <Link to={"/thuat-ngu/" + t.slug}>Đọc ví dụ và giải thích →</Link>
          </details>
        ))}
        {!terms.length && <p>Chưa có kết quả. Thử từ khóa ngắn hơn.</p>}
        <p className="muted">Đóng khung để tiếp tục nhập liệu.</p>
      </dialog>
    </>
  );
}
/**
 * Cuối trang công cụ: việc tiếp theo trên lộ trình 5 trạm (lấy từ
 * src/data/lo-trinh.js), để người dùng đi trạm → việc → công cụ → việc kế
 * mà không phải tự chọn. Công cụ nằm ngoài lộ trình thì dùng gợi ý cũ trong
 * nextSteps.js. Công cụ Điểm sẵn sàng đã có khối "Trạm nên bắt đầu" riêng.
 */
export function NextSteps({ tool }) {
  const tiep = viecTiepTheo(tool.slug);
  // Ngành chọn ở Trạm 2 chỉ đọc sau khi mount (trang được render sẵn).
  const [nganh, setNganh] = useState("");
  useEffect(() => {
    try { setNganh(window.localStorage.getItem(KHOA_NGANH) || ""); } catch { /* bỏ qua */ }
  }, []);

  if (tool.slug === "diem-san-sang-goi-von") return null;
  if (!tiep) {
    return (
      <NextStep steps={CONG_CU[tool.toolId]} nguon={tool.toolId} boQua={tool.toolId}>
        <p className="workspace-link">
          <Link to="/ban-chuan-bi">Xem bản nháp và checklist của tôi →</Link>
        </p>
      </NextStep>
    );
  }
  const { tram, viec, stt, tongViec, sangTram } = tiep;
  const to = linkViec(tram, viec, nganh);
  return (
    <section className="buoc-tiep viec-tiep surface" aria-labelledby="viec-tiep-tieu-de">
      <p className="eyebrow">
        {sangTram
          ? `XONG TRẠM ${tram.so - 1}, SANG TRẠM ${tram.so}/${SO_TRAM}: ${tram.ten.toUpperCase()}`
          : `TRẠM ${tram.so}/${SO_TRAM}, VIỆC ${stt}/${tongViec}`}
      </p>
      <h2 id="viec-tiep-tieu-de">Việc tiếp theo: {viec.ten.charAt(0).toLowerCase() + viec.ten.slice(1)}</h2>
      <p className="viec-tiep-chuan-bi"><span>Chuẩn bị:</span> {viec.chuanBi}</p>
      {viec.khi && <p className="viec-khi">{viec.khi}</p>}
      <div className="buoc-tiep-chinh">
        <Link
          className="nut"
          to={to}
          onClick={() => {
            track("bam_viec", { tram: tram.id, viec: stt, dich: "sau_cong_cu" });
            track("next_step_click", { tool: tool.toolId, target: to });
          }}
        >
          {viec.nhan} →
        </Link>
      </div>
      <p className="buoc-tiep-phu">
        Hoặc: <Link to={linkTram(tram)}>Xem cả Trạm {tram.so}</Link>
        {" hoặc "}
        <Link to="/ban-chuan-bi">Bản nháp và checklist của tôi</Link>
      </p>
    </section>
  );
}
